export const hihat = [2,0,4e3,,,.03,2,1.25,,,,,.02,6.8,-0.3,,.5];
export const claps = [1,0,655,,,.11,2,1.65,,,,,,3.8,-0.1,.1];
export const bassDrum = [1,0,84,,,.1,,.7,,,,.5,,6.7,1,.05];
export const bassDrum2 = [3,0,43,0,,0.25,,,,,,,,2];
export const snare = [1,0,655,0,,.09,3,1.65,,,,,.02,3.8,-0.1,,.2];
export const snare2 = [1,0,219,,,,,1.1,,-.1,-50,-.05,-.01,1];
export const hihatOpen = [.8,0,2100,,,.2,3,3,,,-400,,,2];
export const shaker = [.3,0,900,.02,,.07,4,0,,,,,,4];
